declare const window: Window & { dataLayer: Record<string, unknown>[] };
export const pushToDataLayer = (body: any) => {
  window.dataLayer = window?.dataLayer || [];
  window.dataLayer.push(body);
};
